import React from 'react';
import { View, Flex, Switch } from '@adobe/react-spectrum';

interface TBDNASelectorProps {
  value: 'TBD' | 'N/A' | null;
  onChange: (value: 'TBD' | 'N/A' | null) => void;
  isDisabled?: boolean;
  disableNA?: boolean;
  disableTBD?: boolean;
}

export const TBDNASelector: React.FC<TBDNASelectorProps> = ({
  value,
  onChange,
  isDisabled,
  disableNA,
  disableTBD
}) => {
  return (
    <Flex
      direction="column"
      alignItems="center"
      width="100%"
      UNSAFE_className="tbdna-section"
      data-testid="tbdna-section"
    >
      <Flex
        direction="row"
        alignItems="center"
        UNSAFE_style={{ gap: '18px' }}
        data-testid="tbdna-container"
      >
        <Switch
          isSelected={value === 'TBD'}
          onChange={() => onChange(value === 'TBD' ? null : 'TBD')}
          isDisabled={isDisabled || !!disableTBD}
          UNSAFE_className="tbdna-switch"
          UNSAFE_style={{ marginRight: 0 }}
          aria-label="TBD toggle"
          data-testid="tbdna-switch-tbd"
        >
          TBD
        </Switch>
        <Switch
          isSelected={value === 'N/A'}
          onChange={() => onChange(value === 'N/A' ? null : 'N/A')}
          isDisabled={isDisabled || !!disableNA}
          UNSAFE_className="tbdna-switch"
          UNSAFE_style={{ marginRight: 0 }}
          aria-label="N/A toggle"
          data-testid="tbdna-switch-na"
        >
          N/A
        </Switch>
      </Flex>
    </Flex>
  );
};
